import {Component} from '@angular/core';
import {NavParams} from "ionic-angular";

@Component({
    templateUrl: 'rechargeZaloPay.html',
    selector: 'recharge-zalopay-page'
})
export class RechargeZaloPayPage {
    public title: string = "Nạp Tiền Zalo Pay";
    public uidtID: string = '';
    public zaloList: any = [];
    constructor(private navParams: NavParams) {
        this.uidtID = navParams.get("uidt");
        this.zaloList = navParams.get("zaloList");
    }
}



// WEBPACK FOOTER //
// ./src/pages/rechargeZaloPay/rechargeZaloPay.ts